// extracted by mini-css-extract-plugin
module.exports = {"primeFee":"StoreDeliveryFeeText_primeFee__oR7rf","baseFee":"StoreDeliveryFeeText_baseFee__UJC0Z","logo":"StoreDeliveryFeeText_logo__m7RBW"};